import { AD } from '../model/generic.model';
import { redirectToUrl } from '../util/browser-service';
import fetchSavedAds from '../get-data/fetch/fetch-saveads';
import { trackGA4Event } from '../util/ga4-shared';

export interface State {
    savedAds: { [advertId: number]: boolean };
    token: string | undefined;
}

const initialState: State = {
    savedAds: {},
    token: undefined,
};

export const UPDATE_SAVED_ADS = 'UPDATE_SAVED_ADS';
export const updateSavedAds: AD<typeof UPDATE_SAVED_ADS, Partial<State>> = (payload) => ({
    type: UPDATE_SAVED_ADS,
    payload,
});

export const getSaveAdPath = (action, adId, token) =>
    `/savedads/${adId}/${action}?token=${encodeURIComponent(token)}`;

export const TOGGLE_SAVED_AD = 'TOGGLE_SAVED_AD';
export const toggleSavedAd: AD<typeof TOGGLE_SAVED_AD, { advertId: number }> = (payload) => ({
    type: TOGGLE_SAVED_AD,
    payload,
});

export const toggleSavedAdThunk = ({
    advertId,
    token,
    isAlreadySaved,
    trackEventPayload,
}: {
    advertId: number;
    token: string;
    isAlreadySaved: boolean;
    trackEventPayload: { listName: string; } & GA4.BaseClickListingDetails;
}) =>
    async (dispatch) => {
        const action = isAlreadySaved ? 'remove' : 'add';
        const response = await fetchSavedAds({ advertId, action, token });

        if (response) {
            if (response.status === 401) {
                const { redirectURL } = await response.json();

                redirectToUrl(redirectURL);
            } else if (response.status === 200) {
                dispatch(toggleSavedAd({ advertId }));

                trackGA4Event<GA4.FavouriteListingEvent>({
                    event: isAlreadySaved ? 'delete_favourite_listing' : 'favourite_listing',
                    ...trackEventPayload,
                });
            }
        }
    };

type Action = ReturnType<typeof updateSavedAds> | ReturnType<typeof toggleSavedAd>;

export default (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case UPDATE_SAVED_ADS: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case TOGGLE_SAVED_AD: {
            const { advertId } = action.payload;
            return {
                ...state,
                savedAds: {
                    ...state.savedAds,
                    [advertId]: !state.savedAds[advertId],
                },
            };
        }
        default:
            return state;
    }
};
